import * as apis from '@apis'
import Vue from 'vue'

const Login = {
  namespaced: true,
  state: {
    loginUserInfo: {},
    metadata: {},
    portalsStatus: 0, // 0-初始状态 1-请求site中 2-请求结束
    getSiteResolve: [], // 等待请求站点中的 promise resolve 队列
    initDataCount: 0
  },
  getters: {},
  mutations: {
    updateInitDataCount(state, params) {
      state.initDataCount++
    },
    UPDATE__GET_MAIN_PORTALS(state, params) {
      state.loginUserInfo = params
    },
    UPDATE_META_DATA(state, data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((item) => {
          // 向metadata里保存column字段时清空数据，避免出现整个列表都显示“关联”图标
          Vue.set(state.metadata, item, data[item])
        })
      }
    },
    updatePortalsStatus(state, data) {
      state.portalsStatus = data
    }
  },
  actions: {
    updateInitDataCount({ commit }) {
      commit('updateInitDataCount')
    },
    updatePortalsStatus({ commit }, data) {
      commit('updatePortalsStatus', data)
    },
    // 用于修改密码和头像后更新用户数据
    FETCH_GET_MAIN_PORTALS_UPDATE({ commit }) {
      return apis.MediaCloudPortal.getPortals().then((res) => {
        if (res.data.status === 0) {
          commit('UPDATE__GET_MAIN_PORTALS', res.data.data)
          return res.data.data
        }
      })
    },
    FETCH_GET_MAIN_PORTALS({ commit, state, dispatch }, resolve) {
      commit('updatePortalsStatus', 1)
      return apis.MediaCloudPortal.getPortals().then((res) => {
        if (res.data.status === 0) {
          if (resolve && res.data.data.sites && res.data.data.sites.length > 0)
            resolve(Number(res.data.data.sites[0].id))
          // 统一resolve结果，清空resolve队列
          if (state.getSiteResolve.length > 0) {
            state.getSiteResolve.forEach((item) => {
              if (
                typeof item === 'function' &&
                res.data.data.sites &&
                res.data.data.sites.length > 0
              ) {
                item(Number(res.data.data.sites[0].id))
              }
            })
            state.getSiteResolve = []
          }
          if (res.data.data.sites && res.data.data.sites.length > 0)
            commit('UPDATE_META_DATA', { siteId: res.data.data.sites[0].id })
          commit('UPDATE__GET_MAIN_PORTALS', res.data.data)
          commit('updatePortalsStatus', 2)
          return res.data.data
        }
        commit('updatePortalsStatus', 2)
      })
    },
    FETCH_POST_E5_ADMIN_CACHES_ALL() {
      return apis.MediaCloudPortal.postE5AdminCachesAll().then((res) => {
        return res
      })
    },
    FETCH_META_DATA({ commit }, params) {
      commit('UPDATE_META_DATA', params)
    },
    getSiteInfo({ state, dispatch, commit }) {
      if (state.portalsStatus === 0) return dispatch('FETCH_GET_MAIN_PORTALS')
      return false
    },
    getSiteId({ state, dispatch }) {
      return new Promise((resolve) => {
        let sessionSiteId = sessionStorage.getItem('siteId')
        if (sessionSiteId || state.metadata.siteId) {
          if (sessionSiteId) state.metadata.siteId = sessionSiteId
          resolve(Number(sessionSiteId))
        } else {
          switch (state.portalsStatus) {
            case 0: {
              dispatch('FETCH_GET_MAIN_PORTALS', resolve)
              break
            }
            case 1: {
              state.getSiteResolve.push(resolve)
              break
            }
            case 2: {
              dispatch('FETCH_GET_MAIN_PORTALS', resolve)
              break
            }
            default: {
              this.$messege.error('获取站点状态异常')
            }
          }
        }
      })
    }
  }
}

export default Login
